import React, { useCallback } from "react";
import { fetchLicenses, keyFn } from "license/hooks/useLicenses";
import LicenseActions from "license/LicenseList/LicenseActions";
import customColumnRenderers from "license/LicenseList/helpers/customColumnRenderers";
import { PaginatedEntityTable } from "components/common";
const DEFAULT_DISPLAYED_ATTRIBUTES = [
  "license_type",
  "status",
  "products",
  "licensed_to",
  "contact",
  "license_id",
  "start_date",
  "end_date",
  "details",
  "violations"
];
export const DEFAULT_LAYOUT = {
  entityTableId: "licenses",
  defaultPageSize: 20,
  defaultSort: { attributeId: "status", direction: "asc" },
  defaultDisplayedAttributes: DEFAULT_DISPLAYED_ATTRIBUTES,
  defaultColumnOrder: DEFAULT_DISPLAYED_ATTRIBUTES
};
const LicenseList = () => {
  const licenseAction = useCallback(
    ({ id, license_id, details: { contract_id } }) => /* @__PURE__ */ React.createElement(LicenseActions, { id, licenseId: license_id, contractId: contract_id }),
    []
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "licenses",
      entityActions: licenseAction,
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchLicenses,
      keyFn,
      columnRenderers: customColumnRenderers,
      entityAttributesAreCamelCase: false,
      searchPlaceholder: "Search for license"
    }
  );
};
export default LicenseList;
